(function() {    
function storeCollection(collectionHandle, collectionTitle, collectionUrl) {
    const data = {
    handle: collectionHandle,
    title: collectionTitle,
    url: collectionUrl,
    timestamp: Date.now()
    };
    localStorage.setItem('selected_collection', JSON.stringify(data));
}

// Find collection from parent elements
function findCollectionFromElement(element) {
    let currentElement = element;
    let depth = 0;

    while (currentElement && depth < 10) {

        // ✅ Check for .featured-collection-breadcrumb class
        if (currentElement.classList && currentElement.classList.contains('featured-collection-breadcrumb')) {
            const handle = currentElement.getAttribute('data-collection-handle');
            const title = currentElement.getAttribute('data-collection-title');
            const url = currentElement.getAttribute('data-collection-url');

            if (handle && title) {
                return { handle, title, url: url || `/collections/${handle}` };
            }
        }

        // Existing fallback (keep this)
        const handleAttr = currentElement.getAttribute ? currentElement.getAttribute('data-collection-handle') : null;
        if (handleAttr) {
            const titleAttr = currentElement.getAttribute('data-collection-title');
            const urlAttr = currentElement.getAttribute('data-collection-url');
            if (handleAttr && titleAttr) {
                return { handle: handleAttr, title: titleAttr, url: urlAttr || `/collections/${handleAttr}` };
            }
        }

        currentElement = currentElement.parentElement;
        depth++;
    }
    return null;
}

// Track all product clicks
function trackProductClicks() {
    const productLinks = document.querySelectorAll('a[href*="/products/"]');

    productLinks.forEach(link => {
    if (link.hasAttribute('data-collection-tracker')) return;

    link.addEventListener('click', function(e) {

        // Check URL for collection
        const urlMatch = this.href.match(/\/collections\/([^\/?]+)/);
        if (urlMatch && urlMatch[1]) {
        const handle = urlMatch[1];
        const title = handle.replace(/-/g, ' ');
        storeCollection(handle, title, `/collections/${handle}`);
        return;
        }

        // Find collection from parent elements
        const collection = findCollectionFromElement(this);
        if (collection) {
        storeCollection(collection.handle, collection.title, collection.url);
        }
    });

    link.setAttribute('data-collection-tracker', 'true');
    });
}

// Initial tracking
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', trackProductClicks);
} else {
    trackProductClicks();
}

// Watch for dynamically added content
const observer = new MutationObserver(() => {
    trackProductClicks();
});

observer.observe(document.body, {
    childList: true,
    subtree: true
});
})();